// extracted by mini-css-extract-plugin
export default {"tableShowMoreRow":"TableShowMoreRow__tableShowMoreRow___Gb7IP","tableShowMoreRowMessage":"TableShowMoreRow__tableShowMoreRowMessage___ajrDC"};